/** Formatage des dates et durées pour l'affichage (fr-FR, fuseau de la ville). */

const TIME_ZONE = 'Europe/Paris';

const timeFormat = new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit', timeZone: TIME_ZONE });
const dayFormat = new Intl.DateTimeFormat('fr-FR', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: TIME_ZONE,
});
const dayTimeFormat = new Intl.DateTimeFormat('fr-FR', {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: TIME_ZONE,
});

/** Une date illisible ne doit jamais faire échouer un rendu : on n'affiche rien. */
function safeFormat(formatter: Intl.DateTimeFormat, iso: string): string {
  const time = Date.parse(iso);
  return Number.isNaN(time) ? '' : formatter.format(time);
}

export const formatTime = (iso: string): string => safeFormat(timeFormat, iso);
export const formatDay = (iso: string): string => safeFormat(dayFormat, iso);
export const formatDayTime = (iso: string): string => safeFormat(dayTimeFormat, iso);

/** « à l'instant », « il y a 3 min », « il y a 2 h », « il y a 3 j ». */
export function formatAge(ageMs: number): string {
  const minutes = Math.floor(ageMs / 60_000);
  if (minutes < 1) return 'à l’instant';
  if (minutes < 60) return `il y a ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `il y a ${hours} h`;
  return `il y a ${Math.floor(hours / 24)} j`;
}

/** Espace insécable (U+00A0). */
const NBSP = String.fromCharCode(0xa0);

/** « 15 °C » avec espace insécable : la valeur et l'unité ne sont jamais séparées par un retour à la ligne. */
export function formatTemperature(celsius: number): string {
  return Math.round(celsius) + NBSP + '°C';
}

/** Liste lisible : « A, B et C ». */
export function formatList(items: readonly string[]): string {
  return new Intl.ListFormat('fr', { style: 'long', type: 'conjunction' }).format(items);
}
